import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.sectionheader');
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-sectionheader',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.sectionheader/view.scss */
:host {
  display: block;
}

.lookit-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--lookit-space-3);
  margin-bottom: var(--lookit-space-3);
}

.lookit-section-header.is-tight {
  margin-bottom: var(--lookit-space-2);
}

.lookit-section-header__copy {
  min-width: 0;
}

.lookit-section-header__eyebrow,
.lookit-section-header__title,
.lookit-section-header__subtitle {
  margin: 0;
}

.lookit-section-header__eyebrow {
  margin-bottom: 5px;
  color: var(--lookit-color-text-muted);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-bold);
}

.lookit-section-header__title {
  color: var(--lookit-color-text);
  font-size: var(--lookit-font-size-lg);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.25;
}

.lookit-section-header__subtitle {
  margin-top: 5px;
  color: var(--lookit-color-text-soft);
  font-size: var(--lookit-font-size-sm);
  line-height: 1.45;
}

.lookit-section-header__side {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  max-width: 128px;
  padding-top: 2px;
  text-align: right;
}

.lookit-section-header__meta,
.lookit-section-header__action {
  color: var(--lookit-color-text-muted);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-bold);
  line-height: 1.3;
}

.lookit-section-header__action {
  min-height: 32px;
  color: var(--lookit-color-accent-strong);
  font-size: var(--lookit-font-size-sm);
  font-weight: var(--lookit-font-weight-black);
}

@media (max-width: 340px) {
  .lookit-section-header__title {
    font-size: var(--lookit-font-size-md);
  }
  .lookit-section-header__side {
    max-width: 112px;
  }
}`],
})
export class ComponentLookitSectionheaderComponent {
    @Input() eyebrow: string = '';
    @Input() title: string = '';
    @Input() subtitle: string = '';
    @Input() meta: string = '';
    @Input() actionLabel: string = '';
    @Input() tight: boolean = false;
    @Output() action = new EventEmitter<void>();

    public onAction() {
        this.action.emit();
    }
}

export default ComponentLookitSectionheaderComponent;